import React, { useCallback, useEffect, useRef } from 'react';
import { BottomSheet, IconClose, Stack } from '@adc/parallax-component-library';
import { RichText } from 'Components/utility';
const modalStyles = {
    content: {
        overflow: 'auto',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        height: '100%',
    },
};
export const InfoModal = ({ isOpen, title, content, additionalContent, linkText, app, handleClose, }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (isOpen) {
            ref.current?.present();
        }
        else {
            ref.current?.dismiss();
        }
    }, [isOpen]);
    const handleDismiss = useCallback(() => {
        handleClose();
    }, [handleClose]);
    return (React.createElement(BottomSheet, { ref: ref, topNavigationProps: {
            buttonStart: {
                element: React.createElement(IconClose, null),
                onPress: handleClose,
                label: 'close',
            },
            title,
        }, onBackdropClick: handleDismiss, onDismiss: handleDismiss, scrollable: false, testID: "info-modal", enableDynamicSizing: true },
        React.createElement("div", { style: modalStyles.content },
            React.createElement(Stack, { gridRowGap: "$4", flex: 1 },
                React.createElement(RichText, { text: content, color: "$text.100", testID: "content" }),
                React.createElement(RichText, { text: additionalContent, color: app === 'libreView' ? '$text.60' : '$text.100', fontToken: app === 'libreView' ? '$bodySmall.default' : '$bodyBase.default', testID: "additionalContent" }),
                React.createElement(RichText, { color: "$interactive.core.enabled", fontToken: "$bodyBase.strong", text: linkText })))));
};
